const ListProductService = function ListProductService() {
    this.suggestedListClickedPreviously = false;
};

module.exports = ListProductService;



// WEBPACK FOOTER //
// ./src/common/lists/listproducts.service.js